import { Api } from '../api';
import { createUrl } from '../../helpers/uri-factory';

const url = createUrl('messages');

export class Telefono extends Api {
  constructor(http, config = {}) {
    super(http, url, 'telefono', config);
  }
}